/* Team K9 sale runtime: one small script for every sale. The sale's facts come from window.TK9Sale, printed by the
   sale header section from the promo manifest. Everything a sale shows is hidden in the markup and revealed here,
   by the visitor's clock, only inside the sale window: Shopify's page cache cannot show a sale early or late.
   Switches: ?tk9_campaign_preview=1 shows the sale outside its window (QA), ?tk9_campaign_off=1 hides it always. */
(function () {
  "use strict";
  if (window.__tk9Sale) return;
  window.__tk9Sale = true;
  var cfg = window.TK9Sale || {};
  var start = Date.parse(cfg.startsAt), end = Date.parse(cfg.endsAt), code = String(cfg.code || ""), pct = Number(cfg.pct) || 0;
  if (!code || !isFinite(start) || !isFinite(end)) return;

  function q(name) { try { return new URLSearchParams(location.search).get(name); } catch (e) { return null; } }
  var forced = q("tk9_campaign_preview") === "1", off = q("tk9_campaign_off") === "1";
  // test tk9-sale-1: the header decided the half before anything painted. "control" shows nothing, as today's site.
  var arm = cfg.arm === "on" ? "on" : "off";
  function phase() {
    if (off) return "off";
    if (forced) return arm === "on" ? "on" : "control";
    var now = Date.now(), ph = now < start ? "before" : now > end ? "ended" : "on";
    return ph === "on" && arm !== "on" ? "control" : ph;
  }
  // Optional surfaces (the strip on ordinary product pages, the price on collection cards, the Home band) are on when
  // the manifest says so; ?tk9_sale_try=1 shows them on a live page before they are switched on for everyone.
  var trying = q("tk9_sale_try") === "1";
  function want(name) { return trying || !!(cfg.surfaces && cfg.surfaces[name]); }
  function applied() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    return !!m && decodeURIComponent(m[1]).toUpperCase() === code.toUpperCase();
  }
  function applyHref(path) { return "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(path); }
  function pad(n) { return n < 10 ? "0" + n : String(n); }
  function money(cents) { return "$" + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
  // the price with the code: checkout rounds the discount down ($89.99 less 20% is charged as $72.00)
  function cents(text) { var m = String(text || "").replace(/,/g, "").match(/(\d+(?:\.\d{1,2})?)/); return m ? Math.round(parseFloat(m[1]) * 100) : 0; }

  function countdowns() {
    var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
    var d = Math.floor(left / 86400), h = Math.floor((left % 86400) / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
    document.querySelectorAll("[data-tk9-sale-countdown]").forEach(function (n) {
      var t = d > 0 ? d + "d " + pad(h) + "h " + pad(m) + "m" : pad(h) + "h " + pad(m) + "m " + pad(s) + "s";
      if (n.textContent !== t) n.textContent = t;
    });
  }

  // Links marked data-tk9-sale-apply go through Shopify's own discount link while the sale is on, so the code is
  // already on the order when the shopper reaches checkout. Outside the window they are plain links.
  function links(on) {
    document.querySelectorAll("a[data-tk9-sale-apply]").forEach(function (a) {
      var plain = a.getAttribute("data-tk9-sale-apply") || a.getAttribute("href");
      var want = on ? applyHref(plain) : plain;
      if (a.getAttribute("href") !== want) a.setAttribute("href", want);
    });
  }

  // A lander's order box (the tk9-dtc landers): one line under the price. Before the code is applied it offers the
  // code; after, it shows this size's price with the code. The lander's own files are not changed.
  function landerLine(on) {
    var root = document.querySelector(".tkd"), line = document.querySelector("[data-tk9-sale-line]");
    if (!root || !on) { if (line) line.remove(); return; }
    var price = null;
    root.querySelectorAll(".tkd-price").forEach(function (p) { if (!price && p.offsetParent !== null) price = p; });
    if (!price) return;
    if (!line) {
      line = document.createElement("p");
      line.className = "tk9-sale-line"; line.setAttribute("data-tk9-sale-line", ""); line.setAttribute("data-tk9-sale-id", cfg.id || "");
    }
    if (line.previousElementSibling !== price) price.insertAdjacentElement("afterend", line);
    var now = cents((price.querySelector("[data-tkd-price]") || {}).textContent);
    var html;
    if (applied() && now) html = "<b>Sale</b> <span>With code " + code + ": <strong>" + money(now - Math.floor(now * pct / 100)) + "</strong></span>";
    else html = "<b>Sale</b> <a href=\"" + applyHref(location.pathname + location.search) + "\" data-tk9-preserve-query=\"true\" data-el=\"tk9-sale-apply-lander\">" + (now ? money(now - Math.floor(now * pct / 100)) + " with code " + code : pct + "% off with code " + code) + ". Apply it</a>";
    if (line.getAttribute("data-html") !== html) { line.innerHTML = html; line.setAttribute("data-html", html); }
  }

  // An ordinary product page: one strip right under Add to cart (where the owner put the countdown in August).
  function pdpStrip(on) {
    var strip = document.querySelector("[data-tk9-sale-strip]");
    if (!on || !want("pdp") || document.querySelector(".tkd")) { if (strip) strip.remove(); return; }
    var buy = document.querySelector(".product-details .buy-buttons-block, [id^='ProductInformation'] .buy-buttons-block");
    if (!buy || !buy.querySelector("form[action*='/cart/add']")) return;
    if (!strip) {
      strip = document.createElement("aside");
      strip.className = "tk9-sale-strip"; strip.setAttribute("data-tk9-sale-strip", ""); strip.setAttribute("data-tk9-sale-id", cfg.id || ""); strip.setAttribute("aria-label", cfg.label || "Sale");
    }
    if (strip.previousElementSibling !== buy) buy.insertAdjacentElement("afterend", strip);
    var scope = buy.closest(".product-details, [id^='ProductInformation']") || document;
    var now = cents((scope.querySelector("[data-current-price]") || {}).textContent);
    var withCode = now ? money(now - Math.floor(now * pct / 100)) : "";
    var main = applied() && now ? "<span class=\"tk9-sale-strip__main\"><span class=\"tk9-sale-strip__ok\">" + code + " is on your order:</span><strong>" + withCode + "</strong></span>"
      : "<a class=\"tk9-sale-strip__main\" href=\"" + applyHref(location.pathname + location.search) + "\" data-tk9-preserve-query=\"true\" data-el=\"tk9-sale-apply-pdp\"><span class=\"tk9-sale-patch\">" + code + "</span><span class=\"tk9-sale-strip__your\">" + (now ? "Your price <strong>" + withCode + "</strong>" : pct + "% off") + "</span><span class=\"tk9-sale-strip__go\">Apply</span></a>";
    var html = "<span class=\"tk9-sale-strip__top\"><b>" + (cfg.label || "Sale") + "</b><span class=\"tk9-sale-strip__time\">Ends in <i data-tk9-sale-countdown></i></span></span>" + main;
    if (strip.getAttribute("data-html") !== html) { strip.innerHTML = html; strip.setAttribute("data-html", html); }
  }

  // Collection cards: the price with the code under each card's price. The card's own price is not changed.
  function cardNotes(on) {
    var boxes = document.querySelectorAll(".cpg-product-price, .tkb-product .tkb-price");
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i], note = box.querySelector("[data-tk9-sale-with]");
      if (!on || !want("cards")) { if (note) note.remove(); continue; }
      // Chief & Champ episodes keep their own prices: their price test is running and the sale is for gear
      var link = box.closest(".cpg-product-card"); link = link && link.querySelector("a[href*='/products/']");
      if (link && link.getAttribute("href").indexOf("chief-champ") >= 0) { if (note) note.remove(); continue; }
      var c = cents((box.querySelector(".cpg-price-sale, b") || {}).textContent);
      if (!c) continue;
      var t = money(c - Math.floor(c * pct / 100)) + (box.closest(".tkb-product") ? " with " : " with code ") + code;
      if (!note) { note = document.createElement("span"); note.className = "tk9-sale-with"; note.setAttribute("data-tk9-sale-with", ""); note.setAttribute("data-tk9-sale-id", cfg.id || ""); box.appendChild(note); }
      if (note.textContent !== t) { note.textContent = ""; var pill = document.createElement("span"); pill.textContent = t; note.appendChild(pill); }
    }
  }

  // The sale bar once the code is on: same bar, the offer line says it is on the order.
  function barState(on) {
    var bar = document.querySelector(".tk9-sale-bar");
    if (!bar) return;
    bar.toggleAttribute("data-applied", on && applied());
    var offer = bar.querySelector(".tk9-sale-bar__offer");
    if (!offer) return;
    if (!offer.hasAttribute("data-plain")) offer.setAttribute("data-plain", offer.innerHTML);
    var html = on && applied() ? "<b>" + pct + "% off</b> is on your order" : offer.getAttribute("data-plain");
    if (offer.innerHTML !== html) offer.innerHTML = html;
  }

  // The slide cart (product pages and landers): one row above Subtotal. Before the code is on it offers the code and
  // puts it on without leaving the page; after, it says the code is on. The cart's own totals already show the saving.
  function drawerRow(on) {
    var row = document.querySelector("[data-tk9-sale-row]"), sub = document.querySelector("#Tk9CartForm .kcd-sub");
    if (!on || !want("drawer") || !sub) { if (row) row.remove(); return; }
    if (!row) {
      row = document.createElement("div");
      row.className = "tk9-sale-row"; row.setAttribute("data-tk9-sale-row", ""); row.setAttribute("data-tk9-sale-id", cfg.id || "");
    }
    if (row.nextElementSibling !== sub) sub.insertAdjacentElement("beforebegin", row);
    var html = applied()
      ? "<span class=\"tk9-sale-patch\">" + code + "</span><span class=\"tk9-sale-row__text\"><b>" + pct + "% off</b> is on your order</span>"
      : "<span class=\"tk9-sale-patch\">" + code + "</span><span class=\"tk9-sale-row__text\">" + (cfg.label || "Sale") + ": <b>" + pct + "% off</b></span><button type=\"button\" class=\"tk9-sale-row__go\" data-tk9-sale-put data-el=\"tk9-sale-apply-cart\">Apply</button>";
    if (row.getAttribute("data-html") !== html) { row.innerHTML = html; row.setAttribute("data-html", html); }
  }
  // Shopify's own discount link, fetched so the shopper stays in the cart; the cart then redraws with the code on.
  document.addEventListener("click", function (e) {
    var b = e.target && e.target.closest && e.target.closest("[data-tk9-sale-put]");
    if (!b) return;
    e.preventDefault(); b.disabled = true; b.textContent = "Applying";
    fetch(applyHref("/cart.js"), { credentials: "same-origin" }).catch(function () {}).then(function () {
      if (window.TK9Cart && window.TK9Cart.refresh) window.TK9Cart.refresh();
      render();
    });
  });

  function render() {
    var ph = phase(), on = ph === "on";
    document.documentElement.toggleAttribute("data-tk9-sale-on", on);
    document.querySelectorAll("[data-tk9-sale-surface]").forEach(function (n) { var w = n.getAttribute("data-tk9-sale-want"); n.hidden = !(on && (!w || want(w))); });
    document.querySelectorAll("[data-tk9-sale-before]").forEach(function (n) { n.hidden = ph !== "before"; });
    document.querySelectorAll("[data-tk9-sale-ended]").forEach(function (n) { n.hidden = ph !== "ended"; });
    document.querySelectorAll("[data-tk9-sale-applied]").forEach(function (n) { n.hidden = !(on && applied()); });
    document.querySelectorAll("[data-tk9-sale-unapplied]").forEach(function (n) { n.hidden = !(on && !applied()); });
    links(on);
    landerLine(on);
    try { pdpStrip(on); } catch (e) {}
    try { cardNotes(on); } catch (e) {}
    try { barState(on); drawerRow(on); } catch (e) {}
    if (on) countdowns();
  }
  window.TK9SaleRender = render;
  // The half rides on the cart so it lands on the order, for both halves, inside the window only. The hero test's way:
  // XHR (the layout wraps fetch), read back, write only when missing, a few tries at most. Cart attributes written like
  // this reached every gear web order of 10/29 and 10/30, Shop Pay included.
  function armOnCart() {
    var key = "_tk9_sale_arm", tm = 0, tries = 0;
    function x(m, u, b, cb) {
      try {
        var r = new XMLHttpRequest(); r.open(m, u); r.setRequestHeader("Accept", "application/json");
        if (b) r.setRequestHeader("Content-Type", "application/json");
        r.onloadend = function () { var j = null; try { j = JSON.parse(r.responseText); } catch (e) {} cb(r.status >= 200 && r.status < 300 ? j : null); };
        r.send(b ? JSON.stringify(b) : null);
      } catch (e) { cb(null); }
    }
    function ensure(ms) {
      clearTimeout(tm);
      tm = setTimeout(function () {
        x("GET", "/cart.js", null, function (c) {
          if (!c) return;
          if ((c.attributes || {})[key] === arm) { tries = 0; return; }
          if (++tries > 3) return;
          var a = {}; a[key] = arm;
          x("POST", "/cart/update.js", { attributes: a }, function () { ensure(1200); });
        });
      }, ms);
    }
    if (document.readyState === "complete") ensure(1000); else window.addEventListener("load", function () { ensure(1000); }, { once: true });
    document.addEventListener("tk9:cart", function (e) { var v = (e.detail || {}).event; if (v === "tk9_cart_add_confirmed" || v === "tk9_cart_offer_add") { tries = 0; ensure(500); } });
    document.addEventListener("cart:update", function () { tries = 0; ensure(900); });
  }

  function boot() {
    render();
    var ph = phase();
    if (ph === "on" || ph === "control") armOnCart();
    if (ph !== "control") setInterval(render, 1000);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true }); else boot();
})();
